var slider = tns({
	container: ".main-carousel",
	items: 1.2,
	gutter: 20,
	loop: false,
	// slideBy: "page",
	slideBy: 1,
	mouseDrag: true,
	swipeAngle: false,
	controls: false,
	responsive: {
		494: {
			items: 2.2,
		},
		806: {
			items: 3.5,
		},
		1023: {
			items: 3.5,
			controls: true,
			controlsText: [
				`<svg xmlns="http://www.w3.org/2000/svg" width="19.948" height="11.831" viewBox="0 0 19.948 11.831"><path d="M14.032,11.831,12.89,10.7l3.963-3.96H0V5.091H16.853L12.89,1.129,14.032,0l5.916,5.916Z" transform="translate(19.948 11.831) rotate(180)" fill="#fff"/></svg>`,
				`<svg xmlns="http://www.w3.org/2000/svg" width="19.947" height="11.832" viewBox="0 0 19.947 11.832"><path d="M14.032,11.831,12.89,10.7,16.853,6.74H0V5.091H16.853L12.89,1.129,14.032,0l5.916,5.916Z" fill="#fff"/></svg>`,
			],
		},
	},
});

const navLinks = [].slice.call(document.querySelectorAll(".nav-link"));
const closeButton = document.getElementById("closeButton");

navLinks.map((link) => {
	link.addEventListener("click", () => {
		closeButton.checked = false;
	});
});

document.addEventListener("scroll", () => {
	if (window.pageYOffset > 150) {
		document.querySelector(".title-bar").style.backgroundColor =
			"rgba(14, 11, 88, 0.804)";
	} else {
		document.querySelector(".title-bar").style.backgroundColor =
			"transparent";
	}
});

// If no-js is on the html tag, replace it
let noJs = document.querySelector(".no-js");
if (noJs) {
	noJs.classList.add("js");
	noJs.classList.remove("no-js");
}

// document
// 	.querySelector(".js-scroll-into-hello")
// 	.addEventListener("click", function (e) {
// 		e.preventDefault();
// 		document.querySelector(".hello").scrollIntoView({ behavior: "smooth" });
// 	});

// const id = 'profilePhoto';
// const yOffset = -10;
// const element = document.getElementById(id);
// const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

// window.scrollTo({ top: y, behavior: "smooth" });

const links = document.querySelectorAll("[href*='#int_']");

const yOffset = -80;

links.forEach((link) => {
	link.addEventListener("click", (e) => {
		e.preventDefault();
		const id = link.getAttribute("href").substring(1);

		const el = document.getElementById(`${id}`);

		const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

		// console.log("el", el);

		// el.scrollIntoView({ behavior: "smooth" });
		window.scrollTo({ top: y, behavior: "smooth" });
	});
});
